import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login.vue'
import Home from '@/components/Home.vue'
import Select from '@/components/Select.vue'
import Select2 from '@/components/Select2.vue'
import Select2Detail from '@/components/Select2Detail.vue'

Vue.use(Router)

// 公共路由
export const constantRoutes = [{
    path: '/',
    redirect: '/login'
}, {
    path: '/login',
    component: Login
}, {
    path: '/index',
    component: Home
}, {
    path: '/select',
    component: Select
}, {
    path: '/select2',
    component: Select2,
    meta: {title: '国韵华章全国青少年非遗文化艺术展演'}
}, {
    path: '/select2/detail',
    component: Select2Detail,
    meta: {title: '国韵华章全国青少年非遗文化艺术展演'}
}
]

// 防止连续点击多次路由报错
let routerPush = Router.prototype.push;
let routerReplace = Router.prototype.replace;
// push
Router.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(err => err)
}
// replace
Router.prototype.replace = function push(location) {
    return routerReplace.call(this, location).catch(err => err)
}
const rt = new Router({
    mode: 'history', // 去掉url中的#
    scrollBehavior: () => ({
        y: 0
    }),
    routes: constantRoutes
})

rt.beforeEach((to, from, next) => {
    /* 检查用户是否已登录的逻辑 */
    let isAuthenticated = localStorage.getItem('token') || '';
    if (to.path !== '/login' && to.path !== '/select' && to.path !== '/select2'&& to.path !== '/select2/detail' && !isAuthenticated) {
        next('/login'); // 如果用户未登录且尝试访问非登录页面，则重定向到登录页面
    } else {
        next(); // 确保一定要调用 next() 方法
    }
})
export default rt
